import axios from 'axios'

function getEndpointPesquisa(tipo) {
  return tipo === 'FINAL'
    ? '/api/protected/producao-formula-rastreabilidade/lote-final/pesquisar'
    : '/api/protected/producao-formula-rastreabilidade/materia-prima/pesquisar'
}

function getEndpointDetalhe(tipo, id) {
  return tipo === 'FINAL'
    ? `/api/protected/producao-formula-rastreabilidade/lote-final/detalhar/${id}`
    : `/api/protected/producao-formula-rastreabilidade/materia-prima/detalhar/${id}`
}

export default {
  namespaced: true,
  state: {
    lista: [],
    filtroTipo: 'MP',
    filtroLote: '',
    registroSelecionadoId: null,
    detalhe: null,
    recarregarLista: false
  },
  getters: {
    LISTA: state => state.lista,
    FILTRO_TIPO: state => state.filtroTipo,
    FILTRO_LOTE: state => state.filtroLote,
    REGISTRO_SELECIONADO_ID: state => state.registroSelecionadoId,
    DETALHE: state => state.detalhe,
    RECARREGAR_LISTA: state => state.recarregarLista
  },
  mutations: {
    SET_LISTA(state, payload) {
      state.lista = payload
    },
    SET_FILTRO_TIPO(state, payload) {
      state.filtroTipo = payload || 'MP'
    },
    SET_FILTRO_LOTE(state, payload) {
      state.filtroLote = payload
    },
    SET_REGISTRO_SELECIONADO_ID(state, payload) {
      state.registroSelecionadoId = payload
    },
    SET_DETALHE(state, payload) {
      state.detalhe = payload
    },
    SET_RECARREGAR_LISTA(state, payload) {
      state.recarregarLista = payload
    },
    SET_LIMPAR(state) {
      state.lista = []
      state.filtroTipo = 'MP'
      state.filtroLote = ''
      state.registroSelecionadoId = null
    }
  },
  actions: {
    async GET_LISTA(context) {
      const endpoint = getEndpointPesquisa(context.state.filtroTipo)
      const { data } = await axios.get(endpoint, {
        params: {
          lote: context.state.filtroLote
        }
      })
      context.commit('SET_LISTA', data)
      return data
    },
    async GET_DETALHE(context, payload) {
      const tipo = payload?.tipo || context.state.filtroTipo
      const id = payload?.id
      const { data } = await axios.get(getEndpointDetalhe(tipo, id))
      context.commit('SET_DETALHE', data)
      return data
    }
  }
}


// WEBPACK FOOTER //
// ./src/vuex/modulos/producao-formula-rastreabilidade-store.js